export class BackupPolicy {
    'id';
    'name';
    'enabled';
    'resourceSelector';
    'backupPlan';
    'isSecurityScanEnabled';
    'attachedResources';
    'scheduleMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupPolicyResourceSelector",
            "format": ""
        },
        {
            "name": "backupPlan",
            "baseName": "backupPlan",
            "type": "BackupPolicyPlan",
            "format": ""
        },
        {
            "name": "isSecurityScanEnabled",
            "baseName": "isSecurityScanEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
